import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/saint-therapy-coral-springs-fl")({
  beforeLoad: () => {
    throw redirect({ to: "/saint", statusCode: 301 });
  },
});
